import {Injectable, signal} from '@angular/core';
import {CartItemDTO} from "@features/sales/domain/models/cart/cart-item.model";
import {SynchronizableStore} from "@platform/storage/application/storage.synchronizer";

export interface CartState {
  readonly items: CartItemDTO[];
  readonly isLocked: boolean;
}

export const INITIAL_CART_STATE: CartState = {
  items: [],
  isLocked: false,
};

@Injectable({providedIn: 'root'})
export class CartStore implements SynchronizableStore<CartState> {

  private readonly _state = signal<CartState>(INITIAL_CART_STATE);
  readonly state = this._state.asReadonly();

  setLocked(isLocked: boolean): void {
    this.patch({isLocked});
  }

  setItems(items: CartItemDTO[]): void {
    this.patch({items});
  }

  reset(): void {
    this._state.set(INITIAL_CART_STATE);
  }

  patch(partial: Partial<CartState>): void {
    this._state.update((current) => ({...current, ...partial}));
  }
}
